import styled from 'styled-components';

const OptionsWrapper = styled.div`
  max-width: 470px;
  margin: 0 auto; 

  .time-pickers {
    display: flex;
    margin-top: 1em;
    .date-picker-wrapper {
      margin-right: 2em;
      flex: 1em;
    }
    .label {
      font-size: 0.9em;
      margin: 0 0 .25em;
      color: ${p => p.theme.color.label};
    }
    .timers {
      display: flex;
      align-items: center;
      max-width: 180px;
      .rc-time-picker-panel-narrow {
        left: 0 !important;
        max-width: 100%;
      }
      .rc-time-picker-panel-select {
        width: 100%;
      }
    }
    .delimiter {
      padding: 0 .5em;
    }
  }
`;

export default {
  OptionsWrapper,
};